export default "https://cdn-static.gokick.com/assets/b4d66d8cd7eb0aaa0b454a3d41ce872cff261527/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";